import Footer from 'layouts/Footer'
import Navbar from 'layouts/Navbar'
import LoginModal from 'layouts/components/LoginModal'
import NewsCategoryPage from 'pages/NewsCategoryPage'
import NewsDetail from 'pages/NewsCategoryPage/NewsDetail'
import ProfilePage from 'pages/ProfilePage'
import React, { ReactElement } from 'react'
import { Redirect, Route, BrowserRouter as Router, Switch, useLocation } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import CategoryPage from '../pages/CategoryPage'
import DetailPage from '../pages/DetailPage'
import HomePage from '../pages/HomePage'
import NotFoundPage from '../pages/NotFoundPage'
import ROUTES from '../utils/constants/routesConstant'
import FavoritePage from 'pages/FavoritePage'
import StaticPage from 'pages/StaticPage'

export type Routers = {
  path: string | string[]
  element: ReactElement
  exact?: boolean
  isNeedAuth: boolean
  strict?: boolean
}

export function ScrollToTop() {
  const { pathname } = useLocation()

  React.useEffect(() => {
    if (pathname) {
      window.scrollTo(0, 0)
    }
  }, [pathname])

  return null
}

const Routes = () => {
  const { token } = useAuth()

  const router: Routers[] = [
    {
      path: ROUTES.HOME,
      element: <HomePage />,
      exact: true,
      isNeedAuth: false,
    },
    {
      path: [
        ROUTES.HOUSE,
        ROUTES.BDS_FOR_SELL,
        ROUTES.VEHICLE,
        ROUTES.HOUSE_HOT,
        ROUTES.FLASH_SALE_IN_DAY,
        ROUTES.FLASH_SALE_IN_DAY_COMMING,
        ROUTES.HOUSE_FAVORITE,
        ROUTES.FOR_RENT,
        ROUTES.NEED_SELL,
        ROUTES.PROJECT,
      ],
      element: <CategoryPage />,
      exact: true,
      isNeedAuth: false,
    },
    {
      path: [ROUTES.HOUSE_DETAIL, ROUTES.VEHICLE_DETAIL],
      element: <DetailPage />,
      exact: true,
      isNeedAuth: false,
    },
    {
      path: ROUTES.NOT_FOUND,
      element: <NotFoundPage />,
      isNeedAuth: false,
    },
    {
      path: ROUTES.NEWS,
      element: <NewsCategoryPage />,
      exact: true,
      isNeedAuth: false,
    },
    {
      path: ROUTES.NEWS_DETAIL,
      element: <NewsDetail />,
      isNeedAuth: false,
    },
    {
      path: ROUTES.TRANG_DETAIL_PAGE,
      element: <StaticPage />,
      isNeedAuth: false,
    },
    {
      path: ROUTES.PROFILE,
      element: <ProfilePage />,
      isNeedAuth: true,
    },
    {
      path: ROUTES.FAVORITE_LIST,
      element: <FavoritePage />,
      isNeedAuth: true,
    },
  ]

  const mappingRoute = (router: Routers[]) => {
    if (!router) return
    return (
      <Switch>
        {router.map((item, index) => {
          if (item?.isNeedAuth) {
            if (!token) {
              return <Redirect to="/" key={index} />
            }
            return (
              <Route exact={item.exact} path={item.path} key={index}>
                {item.element}
              </Route>
            )
          }
          return (
            <Route exact={item.exact} path={item.path} key={index}>
              {item.element}
            </Route>
          )
        })}
      </Switch>
    )
  }

  return (
    <Router>
      <Navbar />
      <LoginModal />
      {mappingRoute(router)}
      <Footer />
      <ScrollToTop />
    </Router>
  )
}

export default Routes
